import { arrayOf, bool, number, shape, string } from 'prop-types'

export const resultsStateType = {
  rawResults: arrayOf(
    shape({
      hits: arrayOf(shape({})),
      query: string,
      index: string,
      hitsPerPage: number,
      nbHits: number,
      nbPages: number,
      page: number,
      exhaustiveFacetsCount: bool,
      disjunctiveFacets: arrayOf(shape({})),
      hierarchicalFacets: arrayOf(shape({})),
      facets: shape({}),
    })
  ),
  state: shape({
    index: string,
    query: string,
    facets: arrayOf(shape({})),
    disjunctiveFacets: arrayOf(string),
    hierarchicalFacets: arrayOf(shape({})),
    facetsRefinements: shape({}),
    facetsExcludes: shape({}),
    disjunctiveFacetsRefinements: shape({}),
    numericRefinements: shape({}),
    tagRefinements: arrayOf(shape({})),
    hierarchicalFacetsRefinements: shape({}),
    hitsPerPage: number,
    maxValuesPerFacet: number,
    page: number,
    filters: string,
    facetingAfterDistinct: bool,
  }),
}
